// extracted by mini-css-extract-plugin
export default {"icon":"ItemList_icon__LZdKb","body":"ItemList_body__oy6X+","wrap":"ItemList_wrap__TalN6"};